import * as React from "react";
import { USFlag } from "../../components/atoms/FlagsSvg";

export interface ILanguageConfig {
    readonly code: string;
    readonly name: string;
    readonly flag: React.ReactElement;
    readonly emoji: string;
}

export const SUPPORTED_LANGUAGES: ReadonlyArray<ILanguageConfig> = [
    { code: "en", name: "English", flag: React.createElement(USFlag), emoji: "🇺🇸" },
];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((lang) => lang.code);

export const DEFAULT_LANGUAGE = "en" as const;

export const FALLBACK_LANGUAGES = SUPPORTED_LANGUAGE_CODES;
